export const FireBaseConfig = {
  apiKey: "AIzaSyAX7431Qof0jkuCgTpvR9w_4By81q9N7gI",
  authDomain: "https://ng-orders-8409d.firebaseio.com/",
  databaseURL: "https://ng-orders-8409d.firebaseio.com/",
  projectId: "https://ng-orders-8409d.firebaseio.com/",
  storageBucket: "ng-orders-8409d",
  messagingSenderId: "15443042062"
};
